/**
 * Kachel-URL der Karte — zur **Laufzeit** gesetzt, nicht im Quelltext.
 *
 * 🔴 Der Grund: Die Kartenkomponente des SDK wird in jedes Marken-Template
 * hineingebaut. Ein Schlüssel im Quelltext läge damit eingebacken in jedem
 * gepackten Bundle; ein Schlüsselwechsel wäre eine Runde durch alle
 * Template-Repos samt Neu-Hochladen, statt eines Datensatzes in der Datenbank.
 *
 * Deshalb liefert der Server die fertige URL mit der Antwort von
 * `/vcard/context` (Feld `mapTileUrl`, gebaut aus `brand.mapsApiKey`), und der
 * Viewer legt sie hier ab. Ein dynamisch geladenes Template-Bundle teilt sich
 * mit dem Viewer keine Module — der Weg führt deshalb über `window`, genau wie
 * beim React-Sharing (`__VCARD_HOST_REACT__`, siehe `src/index.tsx`).
 *
 * ⚠️ Der Schlüssel ist damit öffentlich. Das ist bei Kachel-Schlüsseln normal;
 * abgesichert wird er beim Anbieter über eine Domain-Beschränkung.
 */

/** Ohne Schlüssel liefert CARTO Kacheln mit dem Wasserzeichen „API KEY REQUIRED". */
export const FALLBACK_TILE_URL =
  'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png'

const SCHLUESSEL = '__VCARD_MAP_TILE_URL__'

type Fenster = Window & { [SCHLUESSEL]?: string }

/** Übernimmt die vom Server gelieferte URL. Leere Werte werden ignoriert. */
export function setMapTileUrl(url: string | undefined | null): void {
  if (typeof window === 'undefined') return
  const wert = (url ?? '').trim()
  if (!wert) return
  ;(window as Fenster)[SCHLUESSEL] = wert
}

/**
 * Die aktuell gültige Kachel-URL — oder die schlüssellose Vorlage.
 *
 * Eine Karte mit Wasserzeichen ist besser als eine leere Fläche: der Fallback
 * ist absichtlich funktionsfähig und nicht `undefined`.
 */
export function getMapTileUrl(): string {
  if (typeof window === 'undefined') return FALLBACK_TILE_URL
  return (window as Fenster)[SCHLUESSEL] || FALLBACK_TILE_URL
}
